export const APP_REDUCER_NAME = 'common'
export const APP_NOTIFICATIONS_REDUCER_NAME = 'notifications'
export const APP_MODALS_REDUCER_NAME = 'modals'
export const APP_TOOLTIP_REDUCER_NAME = 'tooltip'
export const APP_CONFIG_REDUCER_NAME = 'config'
export const APP_DASHBOARD_TILES_REDUCER_NAME = 'dashboardTiles'
